import DateFnsUtils from '@date-io/date-fns'
import { Grid, Typography } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import { CustomSelect, CustomInput } from '../../components/CustomForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { useLead } from '../../hooks/Features/useLeads'
import { ROUTES } from '../../shared/constants'
import CustomImage from '../../components/CustomImage'
import EditIcon from '../../assets/images/icons/edit.svg'
import { EmployeeContext } from '../../context api/Employee/EmployeeContext'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'

export default function EditLead() {
  const params = useParams()
  const { getLead, lead, editLead, loading } = useLead()
  const { getAllLeadType } = useLeadType()
  const { getAllEmployee } = useCompanyAdmin()
  const { employees } = useContext(EmployeeContext)
  const { leadType: leadTypes } = useContext(ConfigurationContext)
  const history = useHistory()
  const [error, setError] = useState(false)

  const [leadForm, setLeadForm] = useState({
    leadStatus: '',
    followUpDate: '',
    validity: '',
    wishList: {},
    leadAmount: 0,
    addedBy: '',
    discount: 0,
    discountType: '',
  })

  const calcTotalPrice = (leadAmount) => {
    if (lead.discountType === 'PERCENTAGE') return parseFloat(((leadAmount * 100) / (100 - parseInt(lead.totalDiscount))).toFixed(2))
    else return parseFloat(leadAmount + parseInt(lead.totalDiscount)).toFixed(2)
  }

  useEffect(() => {
    getAllEmployee({ rank: 6 })
  }, [])

  useEffect(() => {
    getLead({ leadId: params.leadId })
  }, [params.leadId])

  useEffect(() => {
    if (lead) {
      // to store in localStorage('leadproducts')
      let tempWishList = {}
      let tempCount = 0
      let tempPrice = 0
      lead.wishlist.forEach((list) => {
        if (list.productId) {
          tempCount += list.quantity
          tempPrice += list.quantity * list.productId.dealerPrice
          tempWishList[list.productId._id] = {
            color: list.color,
            quantity: list.quantity,
            name: list.productId.name,
            productImage: list.productId.primaryImage,
            productPrice: list.productId.dealerPrice,
          }
        }
      })
      let leadAmount = tempPrice
      // does not exist or, if exist then should be for edit
      if (!localStorage.getItem('leadProducts') || JSON.parse(localStorage.getItem('leadProducts')).flag !== params.leadId) {
        localStorage.setItem('leadProducts', JSON.stringify({ flag: params.leadId, count: tempCount, totalPrice: tempPrice, wishList: tempWishList }))
      } else {
        // if already exist then it is changed one take that
        let tempForm = JSON.parse(localStorage.getItem('leadProducts'))
        tempWishList = tempForm.wishList
        leadAmount = tempForm.totalPrice
        // if (leadForm.discountType === 'PERCENTAGE') leadAmount = ((leadAmount * (100 - leadForm.discount)) / 100).toFixed(2)
        // else leadAmount -= leadForm.discount
      }

      setLeadForm({
        leadStatus: lead.leadStatus,
        followUpDate: lead.followUp,
        validity: lead.validity,
        wishList: tempWishList,
        leadAmount: leadAmount,
        addedBy: lead && lead.addedBy && lead.addedBy._id,
        discountType: lead && lead.discountType,
        discount: lead.totalDiscount,
        remarks: lead.remarks,
      })
    }
  }, [lead])

  const discountTypeOptions = [
    { name: 'Amount', value: 'AMOUNT' },
    { name: 'Percentage', value: 'PERCENTAGE' },
  ]
  let status = ['CLOSED', 'ACTIVE', 'SUCCESS', 'PARTIAL SUCCESS']
  const inputField = [
    { label: 'Follow Up', value: leadForm.followUpDate, name: 'followUpDate', type: 'DATE' },
    { label: 'Validity', value: leadForm.validity, name: 'validity', type: 'DATE' },
    {
      label: 'Created By',
      value: leadForm.addedBy,
      name: 'addedBy',
      options: employees,
      fieldValue: '_id',
      fieldName: 'firstName',
    },
    {
      label: 'Status',
      value: leadForm.leadStatus,
      name: 'leadStatus',
      options: status,
    },
    {
      label: 'Discount Type',
      value: leadForm.discountType,
      name: 'discountType',
      options: discountTypeOptions,
      fieldValue: 'value',
      fieldName: 'name',
    },
    {
      label: 'Discount',
      value: leadForm.discount,
      name: 'discount',
      type: 'number',
      conditions: [
        { cond: (value) => leadForm.discountType === 'AMOUNT' && value < 0, message: 'Enter Valid Amount' },
        { cond: (value) => leadForm.discountType === 'PERCENTAGE' && (value < 0 || value > 100), message: 'Enter Valid Percentage' },
      ],
    },
    { label: 'Remarks', value: leadForm.remarks, name: 'remarks', noValidate: true },
  ]

  const handleUpdateLead = () => {
    let tempWishList = Object.keys(leadForm.wishList).map((item) => {
      return {
        productId: item,
        quantity: leadForm.wishList[item].quantity,
      }
    })

    //let leadAmount = calcTotalPrice(leadForm.leadAmount)
    let leadAmount = leadForm.leadAmount
    if (leadForm.discountType === 'PERCENTAGE') leadAmount = ((leadAmount * (100 - leadForm.discount)) / 100).toFixed(2)
    else leadAmount -= parseInt(leadForm.discount)

    let leadType = ''
    let leadTypeName = ''
    if (leadTypes) {
      leadTypes.forEach((val) => {
        if (val.name === 'Hot') {
          leadType = val._id
          leadTypeName = val.name
        }
      })
    }

    editLead({
      ...lead,
      leadId: params.leadId,
      wishlist: tempWishList,
      customer: lead.customer._id,
      followUp: leadForm.followUpDate,
      leadStatus: leadForm.leadStatus,
      validity: leadForm.validity,
      leadAmount,
      discountType: leadForm.discountType,
      totalDiscount: leadForm.discount,
      addedBy: leadForm.addedBy,
      remarks: leadForm.remarks,
    })
  }

  return (
    <Layout heading="Leads" heading2="Edit" url1={ROUTES.LEADS} none>
      {!lead ? (
        <Loader />
      ) : (
        <HeaderTabLayout
          heading={lead && lead.customer && lead.customer.name}
          tate={leadForm} setState={setLeadForm}
          content={
            <React.Fragment>
              <CustomAddForm state={leadForm} setState={setLeadForm} data={inputField} setError={setError} />
              <Grid item lg={4} style={{ marginTop: '30px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600, cursor: 'pointer' }}>
                  {'Products'}
                  <CustomImage image={EditIcon} style={{ width: '22px', height: '22px', cursor: 'pointer', marginLeft: '22px' }} onClick={() => history.push(ROUTES.SELECT_LEAD_PRODUCTS)} />
                </Typography>
                <Typography style={{ fontSize: '14px', fontWeight: 400 }}>{Object.values(leadForm.wishList).map((val) => val.name + ', ')}</Typography>
              </Grid>
            </React.Fragment>
          }
          redirect={ROUTES.LEADS}
          text="Save"
          addContent={handleUpdateLead}
          loading={loading}
          buttonDisabled={error}
        />
      )}
    </Layout>
  )
}
